module.exports = "<app-navigation [scrollToArgs]=\"scrollToArgs\"></app-navigation>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main